module.exports = __webpack_public_path__ + "assets/f6a6aa1f563ea4f774ebd664d585c540.png";